import { Node } from 'tiptap'
import { setBlockType, textblockTypeInputRule, toggleBlockType } from 'tiptap-commands'

export default class RedHeading extends Node {
    get name() {
        return 'rd'
    }

    get defaultOptions() {
        return {
            levels: [1, 2, 3]
        }
    }

    get schema() {
        return {
            content: 'inline*',
            group: 'block',
            defining: true,
            draggable: false,
            toDOM: node => ["div", { class: "rdclass" }, 0]
        }
    }

    commands({ type, schema }) {
        return attrs => toggleBlockType(type, schema.nodes.paragraph, attrs)
    }

    inputRules({ type }) {
        return this.options.levels.map(level => textblockTypeInputRule(
            new RegExp(`^->\\s$`),
            type,
            () => ({ level }),
        ))
    }


}